var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-app"},[_c('p',[_vm._v("앱을 여는 중입니다... 잠시만 기다려주세요.")]),_c('a',{ref:"iosLink",staticStyle:{"display":"none"},attrs:{"href":_vm.target}},[_vm._v("앱 열기")])])}
var staticRenderFns = []

export { render, staticRenderFns }